import { GlobalFormSchema } from "features/CenterContent/RoleContent/GlobalEvents/types/formSchema";
import { FC, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { Field, FieldErrorText, Text, Textarea } from "shared/components/Spor";
import { useTheme } from "styled-components";

type TextAreaWithCharacterCountProps = {
  label: string;
  formMethods: UseFormReturn<GlobalFormSchema>;
  formField: "NOB.title" | "NOB.description" | "ENG.title" | "ENG.description";
  invalid: boolean;
  errorMessage: string | undefined;
  maxLength: number;
  minHeight?: string;
  disabled?: boolean;
};
export const TextAreaWithCharacterCount: FC<
  TextAreaWithCharacterCountProps
> = ({
  label,
  formMethods,
  formField,
  invalid,
  errorMessage,
  maxLength,
  minHeight,
  disabled = false,
}) => {
  const theme = useTheme();
  const { getValues, setValue } = formMethods;
  const formPath = `globalForm.customTexts.texts.${formField}` as const;
  const [numChars, setNumChars] = useState(getValues(formPath)?.length ?? 0);

  return (
    <Field invalid={invalid}>
      <Textarea
        label={label}
        value={getValues(formPath)}
        maxLength={maxLength}
        onChange={(e) => {
          setNumChars(e.target.value.length);
          setValue(formPath, e.target.value, { shouldValidate: true });
        }}
        minHeight={minHeight}
        disabled={disabled}
      />

      <Text
        variant="sm"
        color={theme.colorTextSecondary}
        position="absolute"
        bottom="5px"
        right="15px"
      >
        {numChars}/{maxLength}
      </Text>
      <FieldErrorText>{errorMessage}</FieldErrorText>
    </Field>
  );
};
